import React, { Fragment } from 'react';
import { Form, Divider, FormField } from 'semantic-ui-react';
import DateTimeInput from '../../DateTimeInput';
import DateInput from '../../DateInput';
import CourtsDropdown from '../../dropdowns/CourtsDropdown';
import SettlementTypesDropdown from '../../dropdowns/SettlementTypesDropdown';

const commonCondition = crmState =>
  crmState === 'c4_court_date_fixed' ||
  crmState === 'c4_post_court_application_negociation' ||
  crmState === 'c4_pending_court_decision' ||
  /^c[5-9]/.test(crmState);

const Litigation = ({ values, onChange, crmState }) => {
  const disabledEdit = {
    nebSentDate: crmState !== 'c0_national_enforcement_body_sent',
    courtId: crmState.startsWith('c0_national_enforcement_body'),
    conciliationAt: crmState !== 'c4_court_date_fixed',
    nRg: crmState !== 'c4_court_date_fixed',
    courtHearingAt:
      !commonCondition(crmState) && crmState !== 'c4_case_referred_to_court',
    courtDecisionDate: crmState !== 'c4_pending_court_decision',
    paxAgreementAmount: !crmState.startsWith('c6'),
    airlineAgreementDate: !crmState.startsWith('c6'),
    settlementType: !crmState.startsWith('c6'),
    legalFees: !crmState.startsWith('c6'),
    refundFromLawyerDate: !/^c[7-9]/.test(crmState),
    refundFromLawyerAmountForPax: !/^c[7-9]/.test(crmState),
    refundFromLawyerLegalFeesAmount: !/^c[7-9]/.test(crmState),
    paxTransferDate: crmState !== 'c7_pax_to_refund',
    paxToTransferAmount: crmState !== 'c7_pax_to_refund'
  };

  const setAgreementAirlineAmountValue = () => {
    const {
      paxAgreementAmount,
      legalFees,
      refundFromLawyerAmountForPax,
      refundFromLawyerLegalFeesAmount
    } = values;
    if (crmState.startsWith('c6')) {
      return Number(paxAgreementAmount) + Number(legalFees);
    }
    return (
      Number(refundFromLawyerAmountForPax) +
      Number(refundFromLawyerLegalFeesAmount)
    );
  };

  return (
    <Fragment>
      <Form.Group widths={4}>
        <FormField disabled={disabledEdit.courtId} width={4}>
          <CourtsDropdown
            name="courtId"
            label="Court Name"
            value={values.courtId || ''}
            onChange={onChange}
          />
        </FormField>
      </Form.Group>
      <Form.Group widths={4}>
        <Form.Input
          disabled={disabledEdit.nRg}
          name="nRg"
          label="n° RG"
          placeholder="n° RG"
          value={values.nRg || ''}
          onChange={onChange}
        />
        <DateTimeInput
          disabled={disabledEdit.courtHearingAt}
          value={values.courtHearingAt}
          onChange={onChange}
          name="courtHearingAt"
          text="New Court Hearing Info"
        />
        <DateInput
          disabled={disabledEdit.courtDecisionDate}
          text="Court Decision"
          date={values.courtDecisionDate}
          onChange={onChange}
          name="courtDecisionDate"
        />
      </Form.Group>
      <Form.Group widths={4}>
        <DateInput
          disabled={disabledEdit.nebSentDate}
          text="NEB Sent"
          date={values.nebSentDate}
          onChange={onChange}
          name="nebSentDate"
        />
        <DateTimeInput
          disabled={disabledEdit.conciliationAt}
          value={values.conciliationAt}
          onChange={onChange}
          name="conciliationAt"
          text="Conciliation Date"
        />
      </Form.Group>
      <Divider />
      <Divider hidden />
      <Form.Group widths={4}>
        <DateInput
          disabled={disabledEdit.airlineAgreementDate}
          text="Agreement"
          date={values.airlineAgreementDate}
          onChange={onChange}
          name="airlineAgreementDate"
        />
        <Form.Input
          disabled={disabledEdit.paxAgreementAmount}
          name="paxAgreementAmount"
          label="PAX Amount"
          placeholder="PAX Amount"
          value={values.paxAgreementAmount || ''}
          onChange={onChange}
        />
      </Form.Group>
      <Form.Group widths={4}>
        <FormField disabled={disabledEdit.settlementType} width={4}>
          <SettlementTypesDropdown
            disabled={disabledEdit.settlementType}
            name="settlementType"
            label="Settlement Type"
            value={values.settlementType || ''}
            onChange={onChange}
          />
        </FormField>
        <Form.Input
          disabled={disabledEdit.legalFees}
          name="legalFees"
          label="Legal Fees"
          placeholder="Legal Fees"
          value={values.legalFees || ''}
          onChange={onChange}
        />
        <Form.Input
          disabled={true}
          name="agreementAirlineAmount"
          label="Agreement Airline Amount"
          placeholder="Agreement Airline Amount"
          value={setAgreementAirlineAmountValue()}
        />
      </Form.Group>
      <Divider />
      <Divider hidden />
      <Form.Group widths={4}>
        <DateInput
          disabled={disabledEdit.refundFromLawyerDate}
          text="Refund From Lawyer"
          date={values.refundFromLawyerDate}
          onChange={onChange}
          name="refundFromLawyerDate"
        />
        <Form.Input
          disabled={disabledEdit.refundFromLawyerAmountForPax}
          name="refundFromLawyerAmountForPax"
          label="Refund From Lawyer Amount For Pax"
          placeholder="Refund From Lawyer Amount For Pax"
          value={values.refundFromLawyerAmountForPax || ''}
          onChange={onChange}
        />
        <Form.Input
          disabled={disabledEdit.refundFromLawyerLegalFeesAmount}
          name="refundFromLawyerLegalFeesAmount"
          label="Refund From Lawyer Legal Fees Amount"
          placeholder="Refund From Lawyer Legal Fees Amount"
          value={values.refundFromLawyerLegalFeesAmount || ''}
          onChange={onChange}
        />
      </Form.Group>
      <Fragment>
        <Divider />
        <Divider hidden />
        <Form.Group widths={4}>
          <DateInput
            disabled={disabledEdit.paxTransferDate}
            text="Pax Transfer"
            date={values.paxTransferDate}
            onChange={onChange}
            name="paxTransferDate"
          />
          <Form.Input
            disabled={disabledEdit.paxToTransferAmount}
            name="paxToTransferAmount"
            label="Pax To Transfer Amount"
            placeholder="Pax To Transfer Amount"
            value={values.paxToTransferAmount}
            onChange={onChange}
          />
        </Form.Group>
      </Fragment>
      <Divider />
      <Divider hidden />
    </Fragment>
  );
};

export default Litigation;



// WEBPACK FOOTER //
// ./src/component/ClaimForm/Form/Litigation.js